/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import * as actionTypes from './ActionTypes';

const axiosPayLoad = {
  filterAndSortList: {},
  tableLoader: false,
};

const reducer = (state = axiosPayLoad, action) => {
  switch (action.type) {
    case actionTypes.SET_FILTER_AND_SORT_DATA:
      return {
        ...state,
        filterAndSortList: action.payload,
      };
    case actionTypes.TABLE_ACTION_LOADER:
      return { ...state, tableLoader: action.payload };
    default:
      return state;
  }
};

export default reducer;
